module.exports = __webpack_public_path__ + "static/media/btn_google_dark_normal_ios.1bb80544.svg";